import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

const PROFILES = [
  { value: 'all', label: 'All brokers' },
  { value: 'beginner', label: 'Beginner friendly' },
  { value: 'crypto', label: 'Crypto trading' },
  { value: 'pro', label: 'Pro trading' },
];

export const BrokerFinderForm = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [profile, setProfile] = useState('all');

  const onSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (query.trim()) params.set('q', query.trim());
    if (profile !== 'all') params.set('profile', profile);
    navigate(`/compare${params.toString() ? `?${params}` : ''}`);
  };

  return (
    <form
      onSubmit={onSubmit}
      role="search"
      aria-label="Find a broker"
      toolname="find_broker"
      tooldescription="Search the neobroker.com broker comparison by name or keyword and trader profile, then open the matching results"
      className="mx-auto max-w-2xl flex flex-col sm:flex-row gap-2 p-2 rounded-2xl backdrop-blur-xl bg-white/60 dark:bg-white/5 border border-white/40 dark:border-white/10 shadow-lg"
      data-testid="broker-finder-form"
    >
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-foreground/40" aria-hidden="true" />
        <input
          type="search"
          name="query"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Broker or topic, e.g. ETF"
          aria-label="Broker name or keyword"
          toolparamdescription="Optional broker name or keyword to search for, e.g. Trade Republic, ETF or crypto"
          className="w-full h-12 pl-12 pr-4 rounded-xl bg-transparent text-foreground placeholder:text-foreground/40 focus:outline-none focus:ring-2 focus:ring-[hsl(210,100%,56%)]"
          data-testid="broker-finder-query"
        />
      </div>
      <select
        name="profile"
        value={profile}
        onChange={(e) => setProfile(e.target.value)}
        aria-label="Trader profile"
        toolparamdescription="Trader profile filter: all, beginner, crypto or pro"
        className="h-12 px-4 rounded-xl bg-white/70 dark:bg-white/10 text-foreground border border-white/40 dark:border-white/10 focus:outline-none focus:ring-2 focus:ring-[hsl(210,100%,56%)]"
        data-testid="broker-finder-profile"
      >
        {PROFILES.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
      </select>
      <button
        type="submit"
        className="h-12 px-6 rounded-xl text-white font-medium bg-gradient-to-r from-[hsl(210,100%,56%)] to-[hsl(190,95%,55%)] hover:opacity-90 transition-opacity"
        data-testid="broker-finder-submit"
      >
        Find brokers
      </button>
    </form>
  );
};
